module.exports = __webpack_public_path__ + "static/img/bystage_02.3d1c0175.svg";